export class AddDynamicAsset {
	static readonly type = "[Dynamic Assets] Add dynamic asset";
	constructor(
		public name: string,
		public path: string,
	) {}
}
